import {GroupingExerciseModel} from './models';
import {GroupingExerciseState, ItemPosition, ItemState} from './classroom/models';
import {itemIdFromPosition} from './classroom/utils';
import { arrayShuffle } from 'lib/helpers';

function initialState(model: GroupingExerciseModel): GroupingExerciseState {
  const itemIds: string[] = [];
  const groupItems: string[][] = [];
  const itemStates: { [index: string]: ItemState; } = {};

  for (let groupIndex = 0; groupIndex < model.groups.length; groupIndex++) {
    let group = model.groups[groupIndex];
    for (let index = 0; index < group.items.length; index++) {
      const position: ItemPosition = {group: groupIndex, index: index};
      const itemId = itemIdFromPosition(position);
      itemIds.push(itemId);
    }
  }

  arrayShuffle(itemIds)

  for (let i = 0; i < model.groups.length; i++)
    groupItems.push([]);

  for (let itemId of itemIds)
    itemStates[itemId] = {checked: false, checkCount: 0};

  return {
    itemOrder: itemIds,
    groups: groupItems,
    items: itemStates
  };
}

class GroupingExerciseUtilsClass {
  readonly initialState = initialState;
}

export const groupingExerciseUtils = new GroupingExerciseUtilsClass();
